import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.dataset.instructions');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { Input, OnInit, HostListener, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-component-dataset-instructions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.dataset.instructions/view.scss */
/* Instruction workspace: a quiet writing canvas with clear editorial hierarchy. */
:host {
  display: block;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.55;
}

*, *::before, *::after {
  box-sizing: border-box;
}

.instructions {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-top: 0;
  border-radius: 0 0 var(--ui-radius, 12px) var(--ui-radius, 12px);
  overflow: clip;
}

button, input, textarea, select {
  font: inherit;
}

:is(button, a, input, textarea, select, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

input, textarea, select {
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  min-height: 36px;
  padding: 6px 10px;
  max-width: 100%;
  width: 100%;
  caret-color: var(--ui-accent);
}

textarea {
  display: block;
  resize: vertical;
  font-size: 16px;
  line-height: 1.8;
  padding: 10px 12px;
}

input::placeholder, textarea::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}

input:disabled, select:disabled, textarea[readonly] {
  background: var(--ui-soft);
  color: var(--ui-muted);
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: default;
  opacity: 0.55;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  background: var(--ui-paper);
  color: var(--ui-text);
}

.button:hover:not(:disabled) {
  background: var(--ui-soft);
}

.button.primary {
  background: var(--ui-accent);
  color: var(--ui-paper);
  border-color: var(--ui-accent);
}

.button.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}

.text-button {
  background: transparent;
  border: 0;
  color: var(--ui-accent-hover);
  min-height: 36px;
  padding: 6px 8px;
  font-size: 13px;
  font-weight: 600;
}

.text-button:hover:not(:disabled) {
  text-decoration: underline;
  text-underline-offset: 3px;
}

a {
  color: var(--ui-accent-hover);
  text-underline-offset: 3px;
}

h2 {
  color: var(--ui-ink);
  font-size: 18px;
  line-height: 1.4;
  font-weight: 650;
  letter-spacing: -0.02em;
  margin: 0;
  overflow-wrap: anywhere;
}

h3 {
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
  margin: 0 0 12px;
}

p {
  margin: 6px 0;
}

small, .muted {
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.65;
}

label {
  display: block;
  font-size: 13px;
  font-weight: 600;
}

label small {
  font-weight: 450;
}

label input, label select, label textarea {
  margin-top: 4px;
  font-weight: 450;
}

.toolbar, .group-heading, .editor-status, .field-label, .actions, .pagination, .create-set, .page-control, .review-request, .review-decision, .export-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar {
  padding: 8px 16px;
  background: var(--ui-paper);
  justify-content: space-between;
  border-bottom: 1px solid var(--ui-line);
}

.toolbar form, .qa-picker form, .source-picker form {
  display: flex;
  gap: 8px;
  min-width: 0;
}

.toolbar form {
  flex: 1;
  max-width: 560px;
}

.toolbar input {
  min-width: 0;
  flex: 1;
}

.toolbar select {
  width: auto;
  max-width: 220px;
}

.create-set {
  padding: 12px 16px;
  border-bottom: 1px solid var(--ui-line);
  align-items: flex-end;
}

.create-set label {
  flex: 1;
  min-width: 200px;
}

.set-row, .item-row {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
  padding: 12px 16px;
  text-align: left;
  color: inherit;
}

.set-row:last-child, .item-row:last-child {
  border-bottom: 0;
}

.set-row:hover, .item-row:hover {
  background: var(--ui-soft);
}

.set-row:hover strong, .item-row:hover strong {
  color: var(--ui-accent);
}

.set-row > span:first-child {
  flex: 1;
  min-width: 0;
}

.set-row strong, .item-row strong {
  color: var(--ui-ink);
  font-size: 15px;
  font-weight: 650;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.set-row small, .export-row small {
  display: block;
  margin-top: 2px;
}

.item-row strong {
  flex: 1;
  min-width: 0;
}

.stage {
  color: var(--ui-muted);
  font-size: 13px;
  font-weight: 500;
  min-width: 55px;
}

.state {
  display: inline-block;
  background: var(--ui-canvas);
  color: var(--ui-text);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.state.approved {
  background: var(--ui-success-soft);
  color: var(--ui-success);
}

.empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--ui-muted);
}

.empty i {
  font-size: 28px;
  color: var(--ui-accent);
  margin-bottom: 12px;
}

.empty h2, .empty h3 {
  color: var(--ui-ink);
}

.group-heading {
  padding: 16px;
  justify-content: space-between;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.group-heading > div:first-child {
  min-width: 0;
}

.group-heading p {
  color: var(--ui-muted);
  font-size: 12px;
  margin: 3px 0 0;
}

.editor-status {
  padding: 4px 16px;
  min-height: 44px;
  background: var(--ui-paper);
  border-bottom: 0;
  font-size: 12px;
  color: var(--ui-muted);
}

.editor-status .text-button {
  margin-left: auto;
}

.unsaved {
  color: var(--ui-warning);
}

.editor-grid {
  display: grid;
  align-items: start;
  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 0.85fr);
}

.writing {
  padding: 12px 20px 20px;
  min-width: 0;
}

.writing > label {
  margin: 14px 0 6px;
}

.writing > label:first-child {
  margin-top: 0;
}

.writing textarea {
  font-size: 16px;
  line-height: 1.8;
}

.writing :is(input, select, textarea, button) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
  scroll-margin-bottom: 88px;
}

#instruction-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.015em;
  min-height: 42px;
}

#instruction-command {
  height: 104px;
  min-height: 104px;
}

#instruction-input {
  height: 128px;
  min-height: 104px;
}

#instruction-output {
  height: 168px;
  min-height: 144px;
}

.classification {
  display: flex;
  gap: 12px;
  margin: 12px 0;
}

.classification label {
  flex: 1;
  min-width: 0;
}

.field-label {
  justify-content: space-between;
  margin-bottom: 6px;
}

.field-label h3, .field-label label {
  margin: 0;
}

.evidence {
  position: sticky;
  top: 16px;
  max-height: calc(100dvh - 32px);
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
  padding: 12px 16px 16px;
  background: var(--ui-paper);
  border-left: 1px solid var(--ui-line);
  min-width: 0;
}

.evidence-entry {
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.evidence-entry strong {
  display: block;
  color: var(--ui-ink);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

blockquote {
  margin: 10px 0;
  padding: 14px;
  background: var(--ui-soft);
  border: 0;
  border-radius: 8px;
  color: var(--ui-text);
  font-size: 16px;
  line-height: 1.8;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 320px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.source-picker label {
  margin-top: 12px;
}

.source-picker form input {
  min-width: 0;
}

.source-picker form .button {
  flex-shrink: 0;
}

.page-control {
  align-items: flex-end;
  margin-bottom: 12px;
}

.page-control label {
  flex: 1;
}

.source-picker textarea {
  font-size: 16px;
}

.qa-picker {
  padding: 12px 16px;
  border-bottom: 1px solid var(--ui-line);
}

.qa-picker form input {
  min-width: 0;
  flex: 1;
}

.qa-picker form button {
  flex-shrink: 0;
  white-space: nowrap;
}

.qa-choice {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
  color: inherit;
}

.qa-choice strong, .qa-choice small {
  display: block;
  overflow-wrap: anywhere;
}

.qa-choice:hover {
  background: var(--ui-selected);
}

.editor-footer {
  border-top: 1px solid var(--ui-line);
  background: var(--ui-paper);
  padding: 12px 16px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.review-request {
  flex: 1;
  align-items: flex-end;
}

.review-request label {
  min-width: 180px;
}

.review-request small {
  flex-basis: 100%;
}

.save-instruction {
  margin-left: auto;
}

.review-decision {
  width: 100%;
  align-items: flex-end;
}

.review-decision label {
  flex: 1;
}

.approval-note {
  flex-basis: 100%;
  color: var(--ui-success);
}

.origin {
  font-size: 12px;
  color: var(--ui-muted);
}

details {
  padding: 8px 0;
}

summary {
  cursor: pointer;
  font-weight: 600;
  min-height: 36px;
  display: list-item;
  align-content: center;
}

.history ol {
  padding-left: 20px;
}

.history li {
  margin: 12px 0;
}

.history li span {
  display: block;
  font-size: 12px;
  color: var(--ui-muted);
}

.distribution {
  margin: 0 16px;
}

.table-wrap {
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

th, td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--ui-line);
}

th {
  color: var(--ui-muted);
  background: var(--ui-soft);
  font-size: 12px;
  font-weight: 600;
}

td {
  font-variant-numeric: tabular-nums;
}

.exports {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding: 20px;
}

.exports > div {
  min-width: 0;
}

.exports > div + div {
  border-left: 1px solid var(--ui-line);
  padding-left: 24px;
}

.export-count {
  color: var(--ui-ink);
  font-size: 20px;
  font-weight: 650;
  margin: 12px 0 16px;
}

.export-row {
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.pagination {
  justify-content: flex-end;
  padding: 8px 16px;
}

.message {
  padding: 10px 16px;
  border-bottom: 1px solid var(--ui-line);
}

.message.error {
  background: #fff3ee;
  color: var(--ui-danger);
}

.message.success {
  background: var(--ui-success-soft);
  color: var(--ui-success);
}

.loading {
  padding: 12px 16px;
  color: var(--ui-muted);
}

.read-loading {
  margin: 0;
  padding: 8px 16px;
  color: var(--ui-muted);
  background: var(--ui-soft);
  font-size: 14px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.work-content {
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}

.work-content[hidden] {
  display: none;
}

.work-content:disabled .set-row, .work-content:disabled .item-row {
  cursor: wait;
}

.content-loading {
  min-height: 260px;
  padding: 20px;
}

.content-loading > p {
  font-weight: 650;
  color: var(--ui-text);
  margin: 0 0 20px;
}

.skeleton {
  display: block;
  background: var(--ui-canvas);
  border-radius: 4px;
  animation: instruction-pulse 1.4s ease-in-out infinite;
}

.skeleton-heading {
  width: 38%;
  height: 20px;
  margin-bottom: 16px;
}

.skeleton-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  border-top: 1px solid var(--ui-line);
}

.skeleton-row .skeleton {
  width: 65%;
  height: 16px;
}

.skeleton-row .short {
  width: 28%;
  height: 12px;
}

.save-bar {
  position: sticky;
  bottom: 0;
  z-index: 4;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
  padding: 8px 16px;
  padding-bottom: max(8px, env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.save-bar > span {
  min-width: 0;
  font-size: 12px;
  color: var(--ui-muted);
}

.save-bar .button {
  margin: 0;
  min-width: 120px;
}

.picker-empty {
  padding: 16px 0;
  color: var(--ui-muted);
}

.check-needed {
  flex-basis: 100%;
  text-align: left;
}

.instructions h2:focus, .instructions h3:focus {
  outline: none;
}

.loading-dialog {
  padding: 24px;
  margin: auto;
  border: 0;
  background: transparent;
  color: var(--ui-ink);
  max-width: calc(100vw - 32px);
  overflow: visible;
}

.loading-dialog::backdrop {
  background: rgba(238, 240, 243, 0.8);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.loading-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 650;
  outline: none;
}

.loading-ring {
  display: block;
  width: 52px;
  height: 52px;
  box-sizing: border-box;
  border: 4px solid var(--ui-line);
  border-top-color: var(--ui-accent);
  border-radius: 50%;
  animation: instruction-spin 0.8s linear infinite;
}

.inline-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: var(--ui-success);
  background: var(--ui-success-soft);
  min-width: 0;
}

.inline-feedback > span {
  flex: 1;
  overflow-wrap: anywhere;
}

.inline-feedback.error {
  color: var(--ui-danger);
  background: #fff3ee;
}

.inline-feedback .text-button {
  flex-shrink: 0;
  color: inherit;
  white-space: nowrap;
}

.save-bar .inline-feedback {
  flex: 1;
  padding: 0;
  background: transparent;
  font-size: 13px;
}

.build-panel {
  padding: 24px;
  max-width: 960px;
  margin: auto;
}

.build-panel > h3 {
  margin-bottom: 16px;
}

.build-source {
  display: grid;
  gap: 12px;
}

.build-source > label:first-child {
  max-width: 300px;
}

.build-search {
  display: flex;
  gap: 8px;
}

.build-search input {
  min-width: 0;
}

.build-search .button {
  flex-shrink: 0;
}

.build-choices {
  max-height: 280px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
  border-block: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.build-choice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 10px 4px;
  border-bottom: 1px solid var(--ui-line);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.65;
  cursor: pointer;
}

.build-choice:last-child {
  border: 0;
}

.build-choice input {
  width: 20px;
  min-height: 20px;
  height: 20px;
  margin: 2px 0;
  flex-shrink: 0;
  accent-color: var(--ui-accent);
}

.build-choice span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.build-choice small {
  display: block;
}

.picked-qa {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.picked-qa button {
  max-width: 100%;
  white-space: normal;
  text-align: left;
}

.build-range, .build-options {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.build-range label {
  width: 130px;
}

.build-options {
  margin-top: 16px;
}

.build-options > label {
  flex: 1;
  min-width: 160px;
}

.build-options .build-goal {
  flex-basis: 100%;
}

.build-confirm {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--ui-line);
}

.build-confirm > div {
  min-width: 0;
}

.build-confirm p {
  overflow-wrap: anywhere;
}

.build-confirm strong {
  color: var(--ui-ink);
  font-size: 15px;
  font-weight: 650;
}

.build-jobs {
  padding: 12px 16px;
  background: var(--ui-paper);
  border-block: 1px solid var(--ui-line);
}

.job-heading, .content-check, .job-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.job-heading {
  font-size: 14px;
}

.build-job progress {
  display: block;
  width: 100%;
  height: 6px;
  accent-color: var(--ui-accent);
  margin: 12px 0;
}

.job-result {
  padding: 10px 0;
  border-top: 1px solid var(--ui-line);
}

.job-result span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.job-result small {
  display: block;
}

.build-choice:has(input:checked) {
  background: var(--ui-selected);
}

.build-choice:hover {
  background: var(--ui-soft);
}

.job-error {
  color: var(--ui-danger);
}

.call-usage {
  font-size: 12px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.past-jobs {
  margin: 0;
}

.past-jobs summary {
  min-height: 36px;
  padding: 6px 0;
  cursor: pointer;
  color: var(--ui-muted);
}

.past-jobs .build-job {
  padding-top: 12px;
}

.build-job + .past-jobs {
  margin-top: 8px;
}

.content-check {
  padding-bottom: 12px;
  margin-bottom: 0;
  border-bottom: 1px solid var(--ui-line);
  flex-wrap: wrap;
  width: 100%;
}

@media (max-width: 1200px) {
  .editor-grid, .exports {
    grid-template-columns: minmax(0, 1fr);
  }
  .exports > div + div {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    padding: 20px 0 0;
  }
  .evidence {
    position: static;
    max-height: none;
    overflow: visible;
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
}
@media (max-width: 767px) {
  input, select, textarea {
    font-size: 16px;
    min-height: 44px;
  }
  .button, .text-button, summary {
    min-height: 44px;
  }
  .toolbar, .group-heading, .editor-footer, .writing, .evidence, .qa-picker, .create-set {
    padding: 12px;
  }
  .toolbar {
    align-items: stretch;
  }
  .toolbar > form, .toolbar > .button {
    width: 100%;
    max-width: none;
  }
  .filter input {
    flex-basis: 100%;
  }
  .filter select {
    flex: 1;
    width: 100%;
    max-width: none;
    min-width: 0;
  }
  .group-heading {
    align-items: stretch;
    gap: 12px;
  }
  .group-heading > .actions {
    width: 100%;
    gap: 8px;
  }
  .group-heading > .actions .button {
    flex: 1 1 130px;
    white-space: normal;
  }
  .item-row, .set-row {
    padding: 12px;
    gap: 10px;
    flex-wrap: wrap;
  }
  .item-row strong {
    flex-basis: calc(100% - 70px);
  }
  .set-row > span:first-child {
    flex-basis: 100%;
  }
  .editor-status {
    padding: 4px 12px;
  }
  .editor-status .text-button {
    margin-left: 0;
  }
  .classification {
    gap: 12px;
    margin: 12px 0;
  }
  #instruction-title {
    font-size: 16px;
    min-height: 44px;
  }
  .writing > label {
    margin-top: 14px;
  }
  .review-request {
    width: 100%;
  }
  .review-request label {
    width: 100%;
    min-width: 0;
  }
  .save-instruction {
    width: 100%;
    margin: 0;
  }
  .review-decision label {
    flex-basis: 100%;
  }
  .exports, .build-panel, .build-jobs {
    padding: 16px 12px;
  }
  .exports {
    gap: 20px;
  }
  .export-row .button {
    width: 100%;
  }
  .save-bar {
    padding: 8px 12px;
    padding-bottom: max(8px, env(safe-area-inset-bottom));
    gap: 8px;
  }
  .save-bar .button {
    width: auto;
    min-width: 110px;
  }
  .save-bar .inline-feedback {
    flex-basis: 100%;
  }
  .save-bar .save-instruction {
    margin-left: auto;
  }
  .inline-feedback {
    padding: 8px 12px;
  }
  .content-loading {
    padding: 16px;
  }
}
@media (max-width: 600px) {
  .build-confirm {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
  .build-source > label:first-child {
    max-width: none;
  }
  .build-range label {
    flex: 1;
    width: auto;
  }
  .build-range small {
    flex-basis: 100%;
  }
  .job-result {
    align-items: flex-start;
  }
  .job-result button {
    flex-shrink: 0;
  }
}
@media (pointer: coarse) {
  .button, .text-button, summary, input:not([type=checkbox]), select {
    min-height: 44px;
  }
}
@media (max-height: 700px) {
  .evidence {
    position: static;
    max-height: none;
    overflow: visible;
  }
  .save-bar {
    position: static;
  }
}
@keyframes instruction-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes instruction-pulse {
  50% {
    opacity: 0.45;
  }
}
@media (prefers-reduced-motion: reduce) {
  .loading-ring, .skeleton {
    animation: none;
  }
}
/* One editorial header keeps the writing canvas near the dataset context. */
.group-heading {
  padding: 10px 16px;
  gap: 8px 16px;
  min-height: 56px;
}

.group-heading > div:first-child {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.group-heading > div:first-child p {
  margin: 0;
}

.group-heading .editor-status {
  padding: 0;
  min-height: 36px;
  margin-left: auto;
  flex: 0 1 auto;
  gap: 8px;
}

.group-heading .editor-status .text-button {
  margin-left: 8px;
}

.group-heading > .actions {
  flex: 0 1 auto;
}

.editor-grid .writing {
  padding-top: 12px;
}

@media (max-width: 767px) {
  .group-heading {
    padding: 10px 12px;
    gap: 8px 12px;
  }
  .group-heading > div:first-child {
    flex: 1 1 100%;
  }
  .group-heading .editor-status {
    flex: 1 1 180px;
    margin: 0;
    min-height: 44px;
    flex-wrap: wrap;
  }
  .group-heading .editor-status .text-button {
    margin-left: 0;
    min-height: 44px;
  }
  .group-heading > .actions {
    width: auto;
    flex: 1 1 auto;
  }
  .group-heading > .actions .button {
    flex: 1 1 auto;
  }
}
@media (max-width: 380px) {
  .group-heading .editor-status {
    flex-basis: 100%;
    justify-content: flex-start;
  }
}
/* Keep the scope and next review action beside the content they explain. */
.set-scope {
  max-width: 60%;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.set-scope small {
  white-space: normal;
  overflow-wrap: anywhere;
}

.result-total {
  margin-right: auto;
  font-variant-numeric: tabular-nums;
}

.picker-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  flex-wrap: wrap;
  padding: 8px 0;
}

.picker-pagination .pager {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.picker-pagination .button {
  min-width: 48px;
}

.qa-state {
  color: var(--ui-text);
}

.qa-state.qa-held {
  color: var(--ui-warning);
}

.latest-feedback {
  display: flex;
  align-items: flex-start;
  gap: 8px 16px;
  flex-wrap: wrap;
  margin: 0 16px 8px;
  padding: 10px 12px;
  border: 1px solid var(--ui-line);
  background: var(--ui-soft);
  border-radius: 8px;
}

.latest-feedback > div {
  flex: 0 1 auto;
  min-width: 0;
}

.latest-feedback strong, .latest-feedback small {
  display: block;
  overflow-wrap: anywhere;
}

.latest-feedback p {
  flex: 1 1 280px;
  min-width: 0;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.latest-feedback .text-button {
  flex-shrink: 0;
  min-height: 32px;
  padding-block: 4px;
}

.export-exclusions {
  padding: 0;
  margin: 8px 0 0;
  list-style: none;
}

.export-exclusion {
  display: flex;
  align-items: center;
  gap: 8px 16px;
  padding: 10px 0;
  border-bottom: 1px solid var(--ui-line);
}

.export-exclusion > div {
  flex: 1;
  min-width: 0;
}

.export-exclusion strong, .export-exclusion small {
  display: block;
  overflow-wrap: anywhere;
}

.export-exclusion .text-button {
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .set-scope {
    max-width: 100%;
  }
  .latest-feedback {
    margin: 0 12px 8px;
  }
  .latest-feedback > div {
    flex-basis: 100%;
  }
  .latest-feedback .text-button {
    min-height: 44px;
  }
  .export-exclusion {
    align-items: flex-start;
  }
}
/* Switching work areas preserves their final geometry and keeps rows stationary. */
@media (prefers-reduced-motion: no-preference) {
  .build-panel, .editor, .exports, .qa-picker {
    animation: none;
  }
  .set-row, .item-row, .qa-choice, .build-choice {
    transition: background-color var(--motion-fast, 120ms), color var(--motion-fast, 120ms);
  }
}
@keyframes instruction-content-arrive {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
/* Instruction sets use the same scan order: identity, total, then review states. */
.instructions select {
  appearance: auto;
}

.instructions .toolbar {
  padding: 12px 16px;
  gap: 8px 12px;
}

.instructions .toolbar :is(input, select) {
  font-size: 14px;
}

.set-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 16px;
  gap: 16px 24px;
  padding: 16px;
}

.set-row > span:first-child {
  min-width: 0;
}

.set-row > span:first-child > strong {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
}

.set-row > span:first-child > small {
  display: block;
  margin-top: 4px;
  font-size: 13px;
}

.set-scope {
  display: grid;
  max-width: none;
  gap: 4px;
  min-width: 0;
}

.set-total {
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.5;
}

.set-total strong {
  display: inline;
  color: var(--ui-ink);
  font-size: 15px;
}

.set-state-scope {
  font-size: 13px;
}

.set-state-counts {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 16px;
  font-size: 13px;
  line-height: 1.5;
}

.set-state-counts > span {
  white-space: nowrap;
}

.set-state-counts b {
  font-size: 14px;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}

.count-draft {
  color: var(--ui-muted);
}

.count-submitted {
  color: var(--ui-accent);
}

.count-revision {
  color: var(--ui-warning);
}

.count-approved {
  color: var(--ui-success);
}

.instructions .scope-summary, .instructions .result-total {
  font-size: 13px;
}

.instructions .item-row {
  min-height: 56px;
}

.instructions .item-row > strong {
  font-size: 15px;
  line-height: 1.5;
}

.instructions .item-row .stage, .instructions .item-row small {
  font-size: 13px;
}

.instructions .writing > label, .instructions .classification label {
  font-size: 14px;
}

@media (max-width: 767px) {
  .instructions .toolbar {
    padding: 12px;
  }
  .instructions .toolbar :is(input, select) {
    min-height: 44px;
    font-size: 16px;
  }
  .set-row {
    grid-template-columns: minmax(0, 1fr) 16px;
    gap: 8px 12px;
    padding: 16px 12px;
  }
  .set-row > span:first-child, .set-row > .set-scope {
    grid-column: 1;
  }
  .set-row > i {
    grid-column: 2;
    grid-row: 1/3;
  }
  .set-state-counts {
    gap: 4px 12px;
  }
  .instructions .item-row > strong {
    font-size: 15px;
  }
}
/* Review feedback retains its meaning without an extra decorative side marker. */
.latest-feedback strong {
  color: var(--ui-warning);
}

.origin, .history li span, th, .picker-pagination .pager {
  font-size: 13px;
}

/* A calm register and form, consistent with QA while retaining its own workflow. */
.instructions .set-list {
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
}

.instructions .toolbar {
  padding: 16px 18px;
  border-color: var(--ui-line);
  background: var(--ui-paper);
}

.instructions .set-row {
  padding: 20px;
  border-color: var(--ui-line);
  background: var(--ui-paper);
}

.instructions .set-row strong {
  font-size: 15px;
  font-weight: 600;
  color: var(--ui-ink);
}

.instructions .item-row {
  padding-block: 16px;
  border-color: var(--ui-line);
}

.instructions .editor input, .instructions .editor textarea {
  border-color: var(--ui-control);
  border-radius: 7px;
}

.instructions .editor textarea {
  font-size: 16px;
  line-height: 1.85;
  color: var(--ui-ink);
}

.instructions .evidence {
  background: var(--ui-soft);
  border-color: var(--ui-line);
  border-radius: 8px;
}

.instructions .save-bar {
  border-color: var(--ui-line);
  background: var(--ui-paper);
}

@media (max-width: 600px) {
  .instructions .toolbar {
    padding: 14px;
  }
  .instructions .set-row {
    padding: 16px;
  }
}
/* Standalone list tools align with the parent tabs; editing keeps its own frame. */
.instructions.list-view {
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.instructions.list-view .toolbar, .instructions.list-view .create-set, .instructions.list-view .pagination {
  padding-inline: 0;
}

.instructions.list-view .set-list:empty {
  display: none;
}

/* Approval is a prerequisite; source validity is checked when preparing an export. */
.instructions .set-row .set-readiness {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  margin-top: 8px;
  color: var(--ui-muted);
  line-height: 1.6;
  font-size: 13px;
}

.set-readiness > span:first-child {
  color: var(--ui-amber, #85550d);
}

.instruction-readiness {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 24px;
  padding: 16px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-soft);
}

.instruction-readiness > div:first-child {
  flex: 1 1 260px;
  min-width: 0;
}

.instruction-readiness strong {
  color: var(--ui-ink);
  font-size: 13px;
  font-weight: 600;
}

.instruction-readiness p {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
  margin: 4px 0 0;
}

.readiness-state {
  display: grid;
  gap: 4px;
  flex: 0 1 auto;
  min-width: 0;
}

.readiness-state > strong {
  color: var(--ui-amber, #85550d);
}

.readiness-state > span {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}

.instruction-readiness .text-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.export-criteria, .export-checked {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
  margin: 8px 0;
}

.export-count strong {
  color: var(--ui-ink);
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}

.export-reasons {
  display: grid;
  gap: 6px;
  list-style: none;
  margin: 12px 0 16px;
  padding: 12px 0;
  border-block: 1px solid var(--ui-line);
}

.export-reasons li {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.6;
}

.export-reasons li > span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.export-reasons strong {
  flex-shrink: 0;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 720px) {
  .instruction-readiness {
    padding: 16px 12px;
    gap: 12px;
  }
  .instruction-readiness > div:first-child, .readiness-state {
    flex-basis: 100%;
  }
}
/* Instruction workspace: a direct next task, compact status disclosure and contextual authoring tools. */
:host {
  display: block;
  min-width: 0;
}

.instructions {
  background: transparent;
  border: 0;
}

.instructions .work-content {
  border: 0;
  background: transparent;
}

.instructions :is(.button, .icon-button) {
  border-radius: var(--ui-control-radius, 9px);
  min-height: 36px;
  font-size: 14px;
  transition: background-color var(--ui-duration, 180ms) var(--ui-ease), border-color var(--ui-duration, 180ms) var(--ui-ease);
}

.instructions :is(input, select, textarea) {
  border-color: var(--ui-control);
  border-radius: var(--ui-control-radius, 9px);
  accent-color: var(--ui-accent);
}

.instructions select {
  appearance: auto;
}

.instructions input[type=checkbox] {
  appearance: auto;
  width: 18px;
  height: 18px;
  min-height: 18px;
  flex: 0 0 18px;
  padding: 0;
}

.instructions .toolbar {
  padding: 14px 18px;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-soft);
  gap: 10px;
}

.instructions.list-view .toolbar {
  padding: 14px 18px;
  border: 1px solid var(--ui-line);
  border-radius: 14px 14px 0 0;
}

.instructions.list-view .create-set {
  padding: 16px 18px;
  background: var(--ui-selected);
  border: 0;
}

.instructions .set-list {
  background: var(--ui-paper);
  border-inline: 1px solid var(--ui-line);
  border-radius: 0;
  box-shadow: none;
}

.instructions .set-row {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(180px, 0.7fr) auto;
  align-items: center;
  gap: 14px 24px;
  padding: 18px 20px;
  background: var(--ui-paper);
  border-color: var(--ui-line);
  transition: background-color var(--ui-duration, 180ms) var(--ui-ease);
}

.instructions .set-identity {
  min-width: 0;
}

.instructions .set-name {
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
  line-height: 1.55;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.instructions .set-name:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.instructions .set-total {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
}

.instructions .set-next-status {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.instructions .set-next-status > strong {
  font-size: 14px;
  font-weight: 600;
}

.instructions .set-next-status > small {
  font-size: 12px;
  color: var(--ui-muted);
  line-height: 1.6;
}

.instructions .set-next {
  white-space: nowrap;
  justify-content: center;
  gap: 10px;
}

.instructions .set-next > i {
  font-size: 11px;
}

.instructions .set-facts {
  margin-top: 5px;
  font-size: 12px;
  color: var(--ui-muted);
}

.instructions .set-facts > summary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  list-style: none;
  cursor: pointer;
}

.instructions .set-facts > summary::before {
  content: "";
  width: 6px;
  height: 6px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(-45deg);
}

.instructions .set-facts[open] > summary::before {
  transform: rotate(45deg);
}

.instructions .set-facts > summary::-webkit-details-marker {
  display: none;
}

.instructions .set-facts-content {
  display: grid;
  gap: 6px;
  margin-top: 6px;
  padding-left: 14px;
  line-height: 1.6;
}

.instructions .set-facts-content .set-state-counts {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 4px 12px;
}

.instructions .set-facts-content .set-state-counts span {
  font-size: 12px;
}

.instructions .set-row:hover:not(:disabled) {
  background: var(--ui-soft);
}

.instructions .set-row > span:first-child > strong {
  font-size: 15px;
  font-weight: 650;
}

.instructions .set-state-counts {
  gap: 8px 16px;
}

.instructions .set-state-counts > span {
  padding: 2px 0;
  border: 0;
  background: transparent;
}

.instructions.list-view .pagination {
  padding: 12px 18px;
  border: 1px solid var(--ui-line);
  border-top: 0;
  border-radius: 0 0 14px 14px;
  background: var(--ui-soft);
}

.instructions.list-view .empty {
  background: var(--ui-paper);
  border: 0;
  padding: 44px 24px;
}

.instructions .group-heading {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 20px;
  padding: 16px 18px;
  background: var(--ui-paper);
  border: 0;
  border-radius: 14px 14px 0 0;
  box-shadow: none;
}

.instructions .group-identity {
  flex: 1 1 260px;
  min-width: 0;
}

.instructions .group-heading .actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.instructions .group-heading h2 {
  font-size: 19px;
  font-weight: 650;
}

.instructions .instruction-readiness {
  display: block;
  padding: 0;
  background: var(--ui-soft);
  border: 0;
  border-top: 1px solid var(--ui-line);
}

.instructions .instruction-readiness > summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 16px;
  list-style: none;
  cursor: pointer;
  padding: 11px 18px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-ink);
}

.instructions .instruction-readiness > summary::-webkit-details-marker {
  display: none;
}

.instructions .instruction-readiness > summary > i {
  font-size: 10px;
  margin-left: auto;
}

.instructions .instruction-readiness[open] > summary > i {
  transform: rotate(180deg);
}

.instructions .readiness-summary {
  color: var(--ui-muted);
  font-size: 12px;
}

.instructions .readiness-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 24px;
  padding: 0 18px 14px;
}

.instructions .readiness-content > p {
  flex: 1 1 260px;
  margin: 0;
}

.instructions .readiness-content .readiness-state {
  font-size: 12px;
  line-height: 1.6;
}

.instructions .readiness-content .text-button {
  font-size: 12px;
  min-height: 32px;
}

.instructions .toolbar.filter {
  background: var(--ui-soft);
}

.instructions .item-row {
  padding: 15px 18px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.instructions .item-row:hover:not(:disabled) {
  background: var(--ui-selected);
}

.instructions .item-row strong {
  font-size: 15px;
}

.instructions :is(.editor, .exports, .build-panel) {
  border: 0;
  border-radius: 0 0 14px 14px;
  background: var(--ui-paper);
  box-shadow: none;
  animation: none;
}

.instructions .editor-grid {
  grid-template-columns: minmax(0, 1.25fr) minmax(280px, 0.75fr);
  gap: 0;
  background: var(--ui-paper);
}

.instructions .writing {
  padding: 20px 24px 28px;
  background: var(--ui-paper);
}

.instructions .writing > label {
  margin-top: 18px;
  font-weight: 600;
  color: var(--ui-ink);
}

.instructions .writing > label:first-child {
  margin-top: 0;
}

.instructions .writing textarea {
  background: var(--ui-paper);
  font-size: 16px;
  line-height: 1.85;
  border-color: var(--ui-control);
  padding: 12px 14px;
}

.instructions .evidence {
  padding: 20px;
  background: var(--ui-soft);
  border-left: 1px solid var(--ui-line);
}

.instructions .evidence-entry {
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-line);
  background: transparent;
}

.instructions .evidence-entry blockquote {
  margin: 12px 0;
  padding: 12px 0;
  border: 0;
  background: transparent;
  border-radius: 0;
  font-size: 16px;
  line-height: 1.85;
}

.instructions .editor-footer, .instructions .save-bar {
  padding: 12px 18px;
  background: var(--ui-soft);
  border-color: var(--ui-line);
}

.instructions .save-bar {
  border-radius: 0 0 14px 14px;
}

.instructions .latest-feedback {
  margin: 0;
  padding: 16px 18px;
  border: 0;
  background: #fff4e8;
}

.instructions .build-panel {
  padding: 22px;
}

.instructions .build-source {
  background: var(--ui-soft);
  padding: 18px;
  border: 0;
  border-radius: 12px;
}

.instructions .build-choices {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 9px;
}

.instructions .build-choice {
  padding: 12px;
}

.instructions .build-choice:has(input:checked) {
  background: var(--ui-selected);
}

.instructions .build-options, .instructions .build-confirm {
  border-color: var(--ui-line);
}

.instructions .exports {
  padding: 22px;
}

.instructions .export-criteria {
  background: var(--ui-soft);
  border: 0;
  border-radius: 12px;
}

.instructions .content-loading {
  background: var(--ui-paper);
  border-radius: 14px;
  padding: 20px;
}

.instructions .skeleton {
  animation: none;
  background: var(--ui-chrome);
}

.loading-dialog {
  border: 0;
  border-radius: 16px;
  box-shadow: var(--ui-overlay-shadow);
}

.loading-dialog::backdrop {
  background: rgba(35, 39, 47, 0.14);
  backdrop-filter: blur(3px);
}

@media (max-width: 1000px) {
  .instructions .set-row {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px 20px;
  }
  .instructions .set-identity {
    grid-column: 1;
    grid-row: 1/3;
  }
  .instructions .set-next-status {
    grid-column: 2;
    grid-row: 1;
  }
  .instructions .set-next {
    grid-column: 2;
    grid-row: 2;
    justify-self: start;
  }
  .instructions .editor-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .instructions .evidence {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
}
@media (max-width: 600px) {
  .instructions :is(.button, .icon-button) {
    min-height: 44px;
  }
  .instructions :is(input:not([type=checkbox]), select, textarea) {
    min-height: 44px;
    font-size: 16px;
  }
  .instructions .toolbar, .instructions.list-view .toolbar, .instructions .group-heading {
    padding: 12px;
  }
  .instructions .set-row {
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 16px 14px;
    gap: 12px;
  }
  .instructions .set-identity {
    grid-column: 1/-1;
    grid-row: 1;
  }
  .instructions .set-next-status {
    grid-column: 1;
    grid-row: 2;
  }
  .instructions .set-next {
    grid-column: 2;
    grid-row: 2;
    max-width: 100%;
    font-size: 12px;
  }
  .instructions .set-next-status > strong {
    font-size: 13px;
  }
  .instructions .set-facts > summary {
    min-height: 34px;
  }
  .instructions .group-heading .actions {
    gap: 6px;
    width: 100%;
  }
  .instructions .group-heading .actions > .primary {
    margin-left: auto;
  }
  .instructions .instruction-readiness > summary {
    padding: 11px 12px;
  }
  .instructions .readiness-content {
    padding: 0 12px 12px;
  }
  .instructions .writing, .instructions .evidence, .instructions .build-panel, .instructions .exports {
    padding: 16px;
  }
  .instructions .build-source {
    padding: 12px;
  }
  .instructions .editor-footer, .instructions .save-bar {
    padding: 12px;
  }
  .instructions .set-state-counts {
    gap: 6px 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .instructions :is(.button, .icon-button, .set-row, .item-row, .qa-choice, .build-choice) {
    transition: none;
    animation: none;
  }
  .loading-dialog::backdrop {
    backdrop-filter: none;
  }
}
/* Stable destinations within the current instruction dataset. */
.instructions .set-workspace-nav {
  display: flex;
  gap: 4px;
  min-width: 0;
  overflow-x: auto;
  padding: 8px 12px;
  border-block: 1px solid var(--ui-line);
  background: var(--ui-soft);
  scrollbar-width: thin;
}

.instructions .set-workspace-nav button {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 7px 11px;
  border: 0;
  border-radius: 7px;
  color: var(--ui-text);
  background: transparent;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
}

.instructions .set-workspace-nav button[aria-pressed=true] {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
}

.instructions .set-workspace-nav button:hover:not(:disabled):not([aria-pressed=true]) {
  background: var(--ui-hover);
}

@media (max-width: 600px) {
  .instructions .set-workspace-nav {
    padding: 8px;
  }
  .instructions .set-workspace-nav button {
    min-height: 44px;
    padding: 8px 10px;
  }
}`],
})
export class ComponentDatasetInstructionsComponent implements OnInit, OnDestroy {
    openRow(event:MouseEvent) { activateListRow(event); }
    @Input() parent:any;
    @ViewChild('loadingDialog') loadingDialog!:ElementRef<HTMLDialogElement>;
    private previousOverflow:string|null=null;
    private deferredFocus='';
    data:any={items:[],templates:[],domains:[],states:{},total:0,page:1,pages:1};
    group:any=null; selected:any=null; form:any=null; baseline=''; busy=false; ready=false; pending=''; error=''; notice='';
    createOpen=false; setName=''; setOperation=''; query=''; itemQuery=''; state=''; stage='';
    private appliedSetQuery=''; private appliedItems={q:'',state:'',stage:''};
    qaPage:any=null; filePage:any=null; private qaAppliedQuery=''; private fileAppliedQuery='';
    private selectedFile:any=null; exportReturn=false;
    sourceOpen=false; sourceQuery=''; files:any[]=[]; sourceKey=''; sourcePage=1; pageData:any=null; quote=''; filesSearched=false;
    qaOpen=false; qaQuery=''; qaRows:any[]=[]; qaSearched=false; reviewer=''; note=''; exportOpen=false; exportData:any=null; exportOperation='';
    buildOpen=false; buildMode='QA'; buildQA:any[]=[]; buildFirst=1; buildLast=1; buildCount=3; buildStage='AUTO'; buildGoal=''; buildPreview:any=null; buildOperation=''; checkOperation=''; jobs:any[]=[]; jobError=''; private jobTimer:any; private viewEpoch=0; private jobPollSerial=0; private reconciledJobs=new Set<string>();
    private dead=false; private noticeTimer:any; private controllers=new Set<AbortController>();
    private retryTask:(()=>Promise<void>)|null=null; retryKind='';
    constructor(@Inject(Service) public service:Service) {}
    async ngOnInit() { await this.service.init(); await this.load(); }
    ngOnDestroy() { this.dead=true; clearTimeout(this.jobTimer); this.closeLoading(); clearTimeout(this.noticeTimer); this.controllers.forEach(c=>c.abort()); }
    uuid() { return Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join(''); }
    get dirty() { return !!this.form && JSON.stringify(this.form)!==this.baseline; }
    get editable() { return !!this.group?.can_edit && this.selected?.status_code!=='SUBMITTED'; }
    get opening() {return ['open_set','open_item','open_export','back_items','back_sets'].includes(this.pending) || (!this.ready && this.pending==='list');}
    get pendingLabel() {return ({
        build_preview:'자료와 생성 조건을 확인하는 중',build_start:'생성을 시작하는 중',build_check:'내용 검사를 시작하는 중',build_cancel:'중단 요청 중',list:'데이터셋을 불러오는 중',create_set:'데이터셋을 만드는 중',open_set:'문항 목록을 불러오는 중',
        items:'문항을 찾는 중',open_item:'문항과 근거를 불러오는 중',save:'초안을 저장하는 중',
        submit:'검수를 요청하는 중',recall:'검수 요청을 회수하는 중',approve:'승인을 저장하는 중',return:'보완 요청을 저장하는 중',
        qa_search:'QA를 찾는 중',qa_seed:'QA와 근거를 가져오는 중',files:'원문 파일을 찾는 중',page:'원문을 불러오는 중',
        open_export:'내보낼 문항을 확인하는 중',export_create:'내보내기 파일을 만드는 중',download:'파일을 준비하는 중',
        back_items:'문항 목록을 불러오는 중',back_sets:'데이터셋을 불러오는 중'
    } as any)[this.pending] || '처리 중';}
    isReadTask(kind:string) {return ['list','items','open_set','open_item','qa_search','files','page','open_export','back_items','back_sets'].includes(kind);}
    get readPending() {return this.busy && this.isReadTask(this.pending);}
    canLeave() { return (!this.busy || this.readPending) && (!(this.dirty || this.note.trim()) || window.confirm('저장하지 않은 내용이 있습니다. 이동하시겠습니까?')); }
    @HostListener('window:beforeunload',['$event'])
    beforeUnload(e:BeforeUnloadEvent) { if(this.dirty || this.note.trim() || (this.busy && !this.readPending)) { e.preventDefault(); e.returnValue=''; } }
    async call(action:string,values:any={}) {
        const controller=new AbortController(); this.controllers.add(controller);
        const timer=setTimeout(()=>controller.abort(),30000);
        try {
            const body=new FormData();
            for(const [k,v] of Object.entries({action,csrf:this.parent.csrf,...values})) body.append(k,String(v));
            const response=await fetch('/wiz/api/component.dataset.instructions/dispatch',{method:'POST',body,credentials:'same-origin',signal:controller.signal});
            const r=await response.json();
            if(this.dead) throw new Error('화면을 닫아 요청을 취소했습니다.');
            if(r.code!==200) throw new Error(r.code===401 ? '로그인이 만료되었습니다. 작성 내용을 보관한 뒤 다시 로그인해 주세요.' : r.data?.message || '요청을 처리하지 못했습니다. 다시 시도해 주세요.');
            return r.data;
        } catch(e:any) {
            if(e?.name==='AbortError') throw new Error('응답이 지연되고 있습니다. 작성 내용은 유지됩니다. 저장 작업이었다면 다시 시도하기 전에 저장 상태를 확인해 주세요.');
            if(e instanceof TypeError || e instanceof SyntaxError) throw new Error('서버에 연결하지 못했습니다. 연결 상태를 확인하고 다시 시도해 주세요.');
            throw new Error(e?.message || '요청을 처리하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
        } finally {clearTimeout(timer);this.controllers.delete(controller);}
    }
    async task(kind:string,fn:()=>Promise<void>) {
        if(this.busy || this.dead) return;
        this.viewEpoch++;
        clearTimeout(this.noticeTimer);this.busy=true;this.pending=kind;this.error='';this.notice='';this.retryTask=null;this.retryKind='';
        const focus=document.activeElement as HTMLElement|null;
        try {
            await this.service.render();
            if(this.dead)return;
            const dialog=this.isReadTask(kind) ? null : this.loadingDialog?.nativeElement;
            if(dialog && !dialog.open) {
                this.previousOverflow=document.body.style.overflow;
                document.body.style.overflow='hidden';
                dialog.showModal();
            }
            await fn();
        }
        catch(e:any) {
            if(!this.dead) {
                this.error=e.message || '처리하지 못했습니다. 다시 시도해 주세요.';
                if(this.isReadTask(kind)) {this.retryTask=fn;this.retryKind=kind;}
            }
        } finally {
            this.closeLoading();this.busy=false;this.pending='';
            if(!this.dead) {
                await this.service.render();
                if(this.deferredFocus){const selector=this.deferredFocus;this.deferredFocus='';await this.focus(selector);}
                if(focus?.isConnected && document.activeElement===document.body) focus.focus({preventScroll:true});
                if(this.notice) this.noticeTimer=setTimeout(()=>{this.notice='';this.service.render();},7000);
            }
        }
    }
    closeLoading() {
        this.loadingDialog?.nativeElement?.close();
        if(this.previousOverflow!==null){document.body.style.overflow=this.previousOverflow;this.previousOverflow=null;}
    }
    async retry() {const fn=this.retryTask,kind=this.retryKind;if(fn)await this.task(kind,fn);}
    dismissFeedback() {this.error='';this.notice='';this.retryTask=null;this.retryKind='';}
    async focus(selector:string) {if(this.busy){this.deferredFocus=selector;return;}await this.service.render();if(!this.dead)document.querySelector<HTMLElement>(selector)?.focus();}
    async load(page=1, pagination=false) {
        const q=pagination ? this.appliedSetQuery : this.query.trim();
        await this.task('list',async()=>{
            this.data=await this.call('list',{q,page});this.appliedSetQuery=q;this.ready=true;
        });
    }
    get setFiltered() {return !!this.appliedSetQuery;}
    get itemsFiltered() {return !!(this.appliedItems.q || this.appliedItems.state || this.appliedItems.stage);}
    clearItemFilters() {
        this.itemQuery='';this.state='';this.stage='';this.appliedItems={q:'',state:'',stage:''};
    }
    async filterItemState(state:string) {if(this.busy)return;this.state=state;await this.refreshItems();}
    qaStatus(value:string) {
        return ({PENDING:'검토 대기',REVIEWED:'사용자 검토 완료',HELD:'보류',EXCLUDED:'제외'} as any)[value] || '검토 상태 미확인';
    }
    get latestFeedback() {
        return this.selected?.history?.find((entry:any)=>entry.status_code==='REVISION_REQUIRED' && entry.note?.trim());
    }
    get sourceChoices() {
        return this.selectedFile && !this.files.some(file=>file.source_key===this.selectedFile.source_key)
            ? [this.selectedFile,...this.files] : this.files;
    }
    selectSource() {
        this.selectedFile=this.sourceChoices.find(file=>file.source_key===this.sourceKey) || null;
        this.pageData=null;this.quote='';
        if(this.buildOpen)this.buildChanged();
        this.service.render();
    }
    async toggleCreate() {if(this.busy || !this.parent?.canWrite)return;this.createOpen=!this.createOpen;if(this.createOpen)await this.focus('#instruction-set-name');}
    async createSet() {
        if(this.busy || !this.parent?.canWrite)return;
        if(!this.setName.trim()) {this.error='데이터셋 이름을 입력해 주세요.';return;}
        if(!this.setOperation)this.setOperation=this.uuid();
        await this.task('create_set',async()=>{
            const g=await this.call('create_set',{id:this.setOperation,name:this.setName.trim()});
            this.group=await this.call('set',{id:g.set_id});this.clearItemFilters();this.createOpen=false;this.setOperation='';this.setName='';
            this.notice='데이터셋을 만들었습니다. 자료를 선택해 초안을 생성하세요.';await this.focus('.group-heading h2');
        });
    }
    setTaskState(row:any) {
        const counts=row.scope_counts || {};
        if(row.scope==='assigned') return Number(counts.SUBMITTED || 0)>0 ? 'SUBMITTED' : '';
        if(Number(counts.REVISION_REQUIRED || 0)>0) return 'REVISION_REQUIRED';
        if(Number(counts.DRAFT || 0)>0) return 'DRAFT';
        if(Number(counts.SUBMITTED || 0)>0) return 'SUBMITTED';
        return '';
    }
    setTaskLabel(row:any) {
        return ({REVISION_REQUIRED:'보완 문항 열기',DRAFT:'초안 확인',SUBMITTED:'검수 요청 보기'} as any)[this.setTaskState(row)] || '문항 보기';
    }
    setTaskSummary(row:any) {
        const state=this.setTaskState(row), counts=row.scope_counts || {};
        if(state) return ({REVISION_REQUIRED:'보완 필요',DRAFT:'초안',SUBMITTED:'검수 요청'} as any)[state]+' '+Number(counts[state] || 0).toLocaleString('ko-KR')+'건';
        return Number(row.scope_total || 0)>0 ? '문항 현황 확인' : '등록된 문항 없음';
    }
    async openSet(g:any, preferredState='') {
        if(!this.canLeave())return;
        const state=['DRAFT','SUBMITTED','REVISION_REQUIRED','APPROVED'].includes(preferredState) ? preferredState : '';
        await this.task('open_set',async()=>{
            const group=await this.call('set',{id:g.set_id,...(state ? {state} : {})});
            this.group=group;this.resetItem();this.exportOpen=false;this.clearItemFilters();
            this.state=state;this.appliedItems.state=state;
        });
        if(!this.error){await this.loadJobs();await this.focus('.group-heading h2');}
    }
    async refreshItems(page=1, pagination=false) {
        const filters=pagination ? {...this.appliedItems} : {q:this.itemQuery.trim(),state:this.state,stage:this.stage};
        const id=this.group.set_id;
        await this.task('items',async()=>{
            try {
                const group=await this.call('set',{id,page,...filters});
                this.group=group;this.appliedItems=filters;this.state=filters.state;this.stage=filters.stage;
            } catch(error) {
                this.state=this.appliedItems.state;this.stage=this.appliedItems.stage;throw error;
            }
        });
    }
    resetItem() {this.viewEpoch++;this.exportReturn=false;this.buildOpen=false;this.buildPreview=null;this.selected=null;this.form=null;this.baseline='';this.sourceOpen=false;this.qaOpen=false;this.pageData=null;this.quote='';this.reviewer='';this.note='';}
    async showItems() {
        if(!this.group || !(this.selected || this.exportOpen || this.buildOpen))return;
        await this.back();
    }
    async back(toSets=false) {
        if(!this.canLeave())return;
        if(!toSets && (this.selected || this.exportOpen || this.buildOpen)) {
            await this.task('back_items',async()=>{const group=await this.call('set',{id:this.group.set_id});this.group=group;this.resetItem();this.exportOpen=false;this.clearItemFilters();});
        } else {
            await this.task('back_sets',async()=>{const data=await this.call('list',{q:this.appliedSetQuery,page:this.data.page});this.data=data;this.resetItem();this.group=null;this.jobs=[];clearTimeout(this.jobTimer);this.exportOpen=false;this.ready=true;});
        }
        if(!this.error)await this.focus(this.group ? '.group-heading h2' : '#instruction-set-search');
    }
    templates() {return this.group?.templates || this.data.templates || [];}
    label(stage:string) {return this.templates().find((x:any)=>x.stage===stage)?.label || stage;}
    status(value:string) {return this.group?.states?.[value] || this.data.states?.[value] || value;}
    date(v:string) {return formatWorkspaceDate(v);}
    newItem() {
        if(!this.canLeave())return;
        this.resetItem();this.exportOpen=false;this.dismissFeedback();
        this.selected={item_id:this.uuid(),revision_no:0,status_code:'DRAFT',errors:[],history:[],reviewers:[],can_edit:true};
        const t=this.templates()[0];
        this.form={title:'',stage:t.stage,domain:'문진·진단',instruction:t.instruction,input:'',output:'',evidence:[],origin:null};
        this.baseline=JSON.stringify(this.form);this.focus('#instruction-title');
    }
    async openItem(row:any, fromExport=false) {
        if(!this.canLeave())return;
        await this.task('open_item',async()=>{this.accept(await this.call('item',{id:row.item_id}));this.exportOpen=false;this.exportReturn=fromExport;});
        if(!this.error)await this.focus('#instruction-command');
    }
    accept(row:any) {
        this.buildOpen=false;this.checkOperation='';this.selected=row;this.form=JSON.parse(JSON.stringify(row.payload));this.baseline=JSON.stringify(this.form);
        this.reviewer=row.reviewer_id || '';this.note='';this.qaOpen=false;this.sourceOpen=false;this.pageData=null;this.quote='';
    }
    applyTemplate() {
        if(!this.editable || this.busy)return;
        const value=this.templates().find((x:any)=>x.stage===this.form.stage)?.instruction;
        if(this.form.instruction && !window.confirm('현재 지시문을 선택한 단계의 기본 지시문으로 바꿀까요?'))return;
        this.form.instruction=value;this.service.render();
    }
    async save() {
        if(!this.editable)return;
        await this.task('save',async()=>{
            const row=await this.call('save',{set_id:this.group.set_id,id:this.selected.item_id,revision:this.selected.revision_no,data:JSON.stringify(this.form)});
            this.accept(row);this.notice='v'+row.revision_no+' 초안을 저장했습니다.';
            try {this.group=await this.call('set',{id:this.group.set_id});} catch {this.notice+=' 목록 집계는 다시 열 때 갱신됩니다.';}
        });
    }
    async transition(decision:string) {
        if(this.dirty) {this.error='변경 내용을 먼저 저장해 주세요.';return;}
        if(decision==='return' && !this.note.trim()) {this.error='보완 사유를 입력해 주세요.';return;}
        await this.task(decision,async()=>{
            this.accept(await this.call('transition',{id:this.selected.item_id,revision:this.selected.revision_no,decision,reviewer:this.reviewer,note:this.note}));
            this.notice=({submit:'검수를 요청했습니다.',recall:'검수 요청을 회수했습니다.',approve:'승인했습니다.',return:'보완을 요청했습니다.'} as any)[decision];
            try {this.group=await this.call('set',{id:this.group.set_id});} catch {this.notice+=' 목록 집계는 다시 열 때 갱신됩니다.';}
        });
    }
    async toggleQA() {if(this.busy)return;this.qaOpen=!this.qaOpen;this.sourceOpen=false;if(this.qaOpen){await this.searchQA();await this.focus('#instruction-qa-query');}}
    async searchQA(page=1, pagination=false) {
        const q=pagination ? this.qaAppliedQuery : this.qaQuery.trim();
        await this.task('qa_search',async()=>{
            const result=await this.call('qa_search',{q,page});
            this.qaRows=result.items;this.qaPage=result;this.qaAppliedQuery=q;this.qaSearched=true;
        });
    }
    async useQA(row:any) {
        if((this.form.input || this.form.output || this.form.evidence.length) && !window.confirm('지시문·입력·기대 답변·근거를 선택한 QA로 바꿀까요?'))return;
        await this.task('qa_seed',async()=>{const seed=await this.call('qa_seed',{item_id:row.item_id});Object.assign(this.form,seed);this.qaOpen=false;this.notice='QA를 가져왔습니다. 진료단계를 확인하고 저장 후 내용 검사를 진행하세요.';});
    }
    async toggleSources() {if(this.busy)return;this.sourceOpen=!this.sourceOpen;this.qaOpen=false;if(this.sourceOpen){await this.searchFiles();await this.focus('#instruction-file-query');}}
    async searchFiles(page=1, pagination=false) {
        const q=pagination ? this.fileAppliedQuery : this.sourceQuery.trim();
        await this.task('files',async()=>{
            const result=await this.call('files',{q,page});
            this.files=result.items;this.filePage=result;this.fileAppliedQuery=q;this.filesSearched=true;
            if(!pagination){this.pageData=null;this.sourceKey='';this.selectedFile=null;this.quote='';}
            if(this.buildOpen && !pagination)this.buildChanged();
        });
    }
    async loadPage() {await this.task('page',async()=>{this.pageData=await this.call('page',{source_key:this.sourceKey,page:this.sourcePage});this.quote='';});}
    selectQuote(e:any) {const v=e.target;if(v.selectionEnd>v.selectionStart)this.quote=v.value.slice(v.selectionStart,v.selectionEnd);}
    addEvidence() {
        if(this.busy)return;
        if(!this.pageData || !this.quote || !this.pageData.content_text.includes(this.quote)) {this.error='원문에서 인용할 부분을 선택해 주세요.';return;}
        if(this.form.evidence.length>=12) {this.error='근거는 최대 12개까지 연결할 수 있습니다.';return;}
        if(!this.form.evidence.some((r:any)=>r.content_unit_id===this.pageData.content_unit_id && r.quote===this.quote)) {
            this.form.evidence.push({content_unit_id:this.pageData.content_unit_id,quote:this.quote,path:this.pageData.storage_object_key,page:this.sourcePage});
        }
        this.sourceOpen=false;this.pageData=null;this.quote='';this.notice='원문 근거를 연결했습니다. 초안을 저장해 주세요.';this.service.render();
    }
    async showChecks() {await this.service.render();const el=document.querySelector<HTMLDetailsElement>('.history');if(el){el.open=true;el.querySelector<HTMLElement>('summary')?.focus();}}
    sourceLink(r:any) {
        const target=this.selected?.evidence_targets?.[r.content_unit_id],path=target?.path || r.path || '',page=target?.page || r.page;
        if(!target?.job)return '/wiz/api/page.sources/pdf?path='+encodeURIComponent(path)+'&page='+encodeURIComponent(page);
        return '/sources?path='+encodeURIComponent(path.slice(0,path.lastIndexOf('/')))+'&result='+encodeURIComponent(path)+'&pdf_page='+encodeURIComponent(page)+'&job='+encodeURIComponent(target.job);
    }
    filename(r:any) {return (r.path || '').split('/').pop();}
    async showExport() {
        if(!this.canLeave())return;
        await this.task('open_export',async()=>{this.exportData=await this.call('export_preview',{id:this.group.set_id});this.resetItem();this.exportOpen=true;this.exportOperation='';});
        if(!this.error)await this.focus('.exports h3');
    }
    async createExport() {
        if(!this.exportOperation)this.exportOperation=this.uuid();
        await this.task('export_create',async()=>{
            const r=await this.call('export_create',{id:this.group.set_id,operation:this.exportOperation,fingerprint:this.exportData.fingerprint});
            this.notice='v'+r.version_no+' 파일을 만들었습니다.';
            this.exportData=await this.call('export_preview',{id:this.group.set_id});this.exportOperation='';
        });
    }
    async download(row:any) {
        await this.task('download',async()=>{
            const res=await fetch('/wiz/api/component.dataset.instructions/dispatch?action=export_download&id='+row.export_id,{credentials:'same-origin'});
            if(!res.ok || !res.headers.get('content-type')?.includes('application/zip')) {
                const v=await res.json();throw new Error(v.data?.message || '다운로드하지 못했습니다.');
            }
            const url=URL.createObjectURL(await res.blob());const a=document.createElement('a');
            a.href=url;a.download='instruction-v'+row.version_no+'.zip';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);this.notice='다운로드를 시작했습니다.';
        });
    }

    get attentionJobs() {return this.jobs.filter(j=>j.state!=='COMPLETED');}
    get pastJobs() {return this.jobs.filter(j=>j.state==='COMPLETED');}
    get jobActive() {return this.jobs.some(j=>['QUEUED','RUNNING'].includes(j.state));}
    buildState(s:string) {return ({QUEUED:'대기 중',RUNNING:'생성·검사 중',COMPLETED:'완료',FAILED:'중단됨',CANCELLED:'사용자 중단'} as any)[s] || s;}
    buildChanged() {this.buildPreview=null;this.buildOperation='';}
    async openBuild() {
        if(!this.canLeave())return;
        this.resetItem();this.exportOpen=false;this.buildOpen=true;this.buildQA=[];this.buildChanged();
        await this.buildModeChanged();await this.focus('#build-source-mode');
    }
    async buildModeChanged() {
        this.buildChanged();
        if(this.buildMode==='QA')await this.searchQA();else await this.searchFiles();
    }
    toggleBuildQA(q:any) {
        const i=this.buildQA.findIndex(x=>x.item_id===q.item_id);
        if(i>=0)this.buildQA.splice(i,1);else if(this.buildQA.length<10)this.buildQA.push(q);
        this.buildCount=Math.max(this.buildCount,this.buildQA.length);this.buildChanged();
    }
    qaPicked(q:any) {return this.buildQA.some(x=>x.item_id===q.item_id);}
    buildData() {return {mode:this.buildMode,qa_ids:this.buildQA.map(x=>x.item_id),source_key:this.sourceKey,
        first:this.buildFirst,last:this.buildLast,count:this.buildCount,stage:this.buildStage,goal:this.buildGoal};}
    async previewBuild() {await this.task('build_preview',async()=>{this.buildPreview=await this.call('build_preview',{id:this.group.set_id,data:JSON.stringify(this.buildData())});this.buildOperation=this.uuid();});}
    async startBuild() {
        if(!this.buildPreview || this.jobActive)return;
        await this.task('build_start',async()=>{
            await this.call('build_start',{id:this.group.set_id,operation:this.buildOperation,
                fingerprint:this.buildPreview.fingerprint,data:JSON.stringify(this.buildData())});
            this.buildOpen=false;this.buildPreview=null;this.notice='생성을 시작했습니다. 완료한 문항은 초안으로 저장됩니다.';
        });await this.loadJobs();
    }
    async checkContent() {
        if(this.dirty || !this.selected?.revision_no || this.jobActive)return;
        if(!window.confirm('현재 버전의 지시문·입력·답변을 검사합니다. OpenAI API 1회 비용이 발생합니다. 진행할까요?'))return;
        if(!this.checkOperation)this.checkOperation=this.uuid();
        await this.task('build_check',async()=>{
            await this.call('build_check',{item_id:this.selected.item_id,revision:this.selected.revision_no,operation:this.checkOperation});
            this.checkOperation='';this.notice='내용 검사를 시작했습니다.';
        });await this.loadJobs();
    }
    async cancelBuild(j:any) {
        await this.task('build_cancel',async()=>{await this.call('build_cancel',{id:j.job_id});});await this.loadJobs();
    }
    refreshScope() {return JSON.stringify([this.group?.set_id,this.group?.page,this.appliedItems,this.selected?.item_id,this.selected?.revision_no]);}
    get needsJobRefresh() {return this.jobs.some(j=>!['QUEUED','RUNNING'].includes(j.state) && !this.reconciledJobs.has(j.job_id));}
    async loadJobs() {
        clearTimeout(this.jobTimer);
        if(!this.group?.can_edit || this.dead)return;
        const sid=this.group.set_id,serial=++this.jobPollSerial;
        const current=()=>!this.dead && this.group?.set_id===sid && serial===this.jobPollSerial;
        try {
            const jobs=await this.call('build_jobs',{id:sid});
            if(!current())return;
            this.jobs=jobs;this.jobError='';
            if(this.needsJobRefresh && !this.busy){
                const epoch=this.viewEpoch,scope=this.refreshScope();
                const safe=()=>current() && !this.busy && this.viewEpoch===epoch && this.refreshScope()===scope;
                const terminal=jobs.filter((j:any)=>!['QUEUED','RUNNING'].includes(j.state)).map((j:any)=>j.job_id);
                const freshGroup=await this.call('set',{id:sid,page:this.group.page,...this.appliedItems});
                let freshItem:any=null;
                if(safe() && this.selected?.revision_no && !this.dirty && !this.note.trim()){
                    const selected=this.selected,baseline=this.baseline;
                    freshItem=await this.call('item',{id:selected.item_id});
                    if(!safe() || this.selected!==selected || this.baseline!==baseline || this.dirty || this.note.trim())freshItem=null;
                }
                if(safe()){
                    this.group=freshGroup;this.notice='';
                    if(freshItem)this.accept(freshItem);
                    terminal.forEach((id:string)=>this.reconciledJobs.add(id));
                }
            }
        } catch(e:any) {if(current())this.jobError=e.message;}
        if(current()){
            await this.service.render();
            if(current() && (this.jobActive || this.jobError || this.needsJobRefresh))this.jobTimer=setTimeout(()=>this.loadJobs(),5000);
        }
    }
    get total() {return (this.group?.stats || []).reduce((n:number,r:any)=>n+Number(r.n),0);}
    get approved() {return (this.group?.stats || []).filter((r:any)=>r.status_code==='APPROVED').reduce((n:number,r:any)=>n+Number(r.n),0);}
}

export default ComponentDatasetInstructionsComponent;